module.exports = __webpack_public_path__ + "static/media/20180808_202522.3cfefec5.jpg";